/* The equivalent to jQuery.timeago for react.
 *
 * TimeAgo returns a span containing the amount of time (in English) that has
 * passed since `time`.
 *
 * Takes:
 *     time: an ISO 8601 timestamp
 *     refreshMillis: how often to update, in milliseconds
 *
 * Example:
 *
 *     return <a href={khanAcademy}><TimeAgo time={date} /></a>
 */

import moment from "moment";
import * as React from "react";

import {
    withActionScheduler,
    type IScheduleActions,
} from "@khanacademy/wonder-blocks-timing";

type OwnProps = {
    refreshMillis?: number;
    time: any;
};

type Props = OwnProps & {
    schedule: IScheduleActions;
};

type State = {
    timeAgo: string;
};

class TimeAgo extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const {schedule} = props;

        schedule.interval(
            () =>
                this.setState({
                    timeAgo: moment(this.props.time).fromNow(),
                }),
            props.refreshMillis || 60000,
        );

        this.state = {
            timeAgo: moment(this.props.time).fromNow(),
        };
    }

    render(): React.ReactNode {
        return <span>{this.state.timeAgo}</span>;
    }
}

export default withActionScheduler(TimeAgo) as React.ComponentType<OwnProps>;
